import { ConfirmModal } from '../../commons/components/ConfirmModal';
import React from 'react';
import { useUpdateTenantNotificationSettingsMutation } from '../hooks/useUpdateTenantNotificationSettingsMutation';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';

export const SmsNotificationsModal = (props: {
  source: string;
  isAdhoc?: boolean;
  onClose?: () => void;
}) => {
  const { source, isAdhoc, onClose } = props;
  useAnalyticsPage(Page.ENABLE_SMS_NOTIFICATIONS, { source });
  const { mutate: updateTenantNotificationSettings } =
    useUpdateTenantNotificationSettingsMutation(source);

  return (
    <ConfirmModal
      title="Would you like to receive text reminders for Growegy invoices?"
      message="Standard message and data rates may apply. You can opt out anytime."
      ariaHideApp={false}
      onClose={onClose}
      footer={{
        type: 'show',
        applyButton: {
          label: 'Enable text reminders',
          onClick: () => updateTenantNotificationSettings({ smsEnabled: true }),
        },
        cancelButton: {
          label: isAdhoc ? 'Ask me later' : 'Cancel',
          onClick: () => {},
        },
        extraButtons: isAdhoc
          ? [
              {
                label: 'No, thanks',
                onClick: () => updateTenantNotificationSettings({ smsEnabled: false }),
              },
            ]
          : undefined,
      }}
    />
  );
};
